/**
 * fetchAllPages: udtøm en PostgREST-kilde side for side (.range()).
 * Supabase/PostgREST returnerer maks. 1000 rækker pr. kald, så tabeller
 * der kan vokse (variantpriser, pris-trin m.m.) skal pagineres.
 *
 * Ren hjælper uden Supabase-afhængighed: `fetchPage(from, to)` leverer én
 * side (inklusive grænser, som .range()); der hentes til en side er kortere
 * end sidestørrelsen.
 */
export async function fetchAllPages<T>(
  fetchPage: (from: number, to: number) => Promise<T[]>,
  pageSize = 1000,
): Promise<T[]> {
  if (pageSize < 1) throw new Error("pageSize skal være mindst 1");
  const rows: T[] = [];
  for (let from = 0; ; from += pageSize) {
    const page = await fetchPage(from, from + pageSize - 1);
    rows.push(...page);
    if (page.length < pageSize) break;
  }
  return rows;
}
